import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { ChunkSearchSchema } from '@/features/data-connector/chunks';
export const Route = createFileRoute('/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks/')({
  validateSearch: zodValidator(ChunkSearchSchema)
});